import { Users2 } from "lucide-react";
import Reveal from "@/components/landing/Reveal";
import { motion } from "framer-motion";
import { renderTitle, toFullUrl } from "@/components/landing/utils";

export default function HumanizationSection({ block }) {
  const people = block?.people || [];
  return (
    <section id="equipo" className="section-elev py-20 md:py-32 relative overflow-hidden" data-testid="humanization-section">
      {["/perfumes/dama-blanco.png", "/perfumes/caballero-60.png"].map((b, i) => (
        <motion.img key={b} src={b} alt="" aria-hidden loading="lazy" decoding="async"
          className={`hidden lg:block absolute w-24 xl:w-32 opacity-70 pointer-events-none drop-shadow-2xl ${i === 0 ? "left-6 top-24" : "right-8 bottom-16"}`}
          animate={{ y: [0, -14, 0], rotate: i === 0 ? [-4, 2, -4] : [3, -3, 3] }} transition={{ duration: 7 + i, repeat: Infinity, ease: "easeInOut" }} />
      ))}
      <div className="gold-glow" style={{ width: 500, height: 500, bottom: -160, left: -120, opacity: 0.5 }} />
      <div className="max-w-[1300px] mx-auto px-6 lg:px-10 relative">
        <div className="max-w-3xl mb-14">
          <Reveal><span className="eyebrow">{block?.eyebrow || "La gente detrás"}</span></Reveal>
          <Reveal delay={120}>
            <h2 className="mt-4 font-display text-4xl md:text-5xl lg:text-6xl text-[#0A0A0A]">
              {renderTitle(block?.title || "Detrás de cada apertura hay un <em>equipo</em>.")}
            </h2>
          </Reveal>
          {block?.body && (
            <Reveal delay={220}>
              <p className="mt-6 text-[#3F3F46] text-base md:text-lg leading-relaxed">{block.body}</p>
            </Reveal>
          )}
        </div>
        <div className="grid lg:grid-cols-[minmax(0,320px)_1fr] gap-6 lg:gap-10 items-center">
          {toFullUrl(block?.video_url) && (
            <Reveal delay={100} scale>
              <div className="relative rounded-3xl overflow-hidden bg-[#0A0A0A] aspect-[9/16] mx-auto w-full max-w-[300px] lg:max-w-[320px] shadow-[0_30px_80px_-30px_rgba(0,0,0,0.5)]" data-testid="humanization-video">
                <video
                  src={toFullUrl(block.video_url)} poster={toFullUrl(block.video_poster) || undefined}
                  autoPlay muted loop playsInline preload="metadata"
                  className="absolute inset-0 w-full h-full object-cover"
                />
                <div className="absolute inset-x-0 bottom-0 h-28 bg-gradient-to-t from-[#0A0A0A]/80 to-transparent pointer-events-none" />
                <div className="absolute bottom-4 left-4 right-4 flex items-center gap-2 text-[9px] uppercase tracking-[0.2em] font-mono text-[#FFBF57]">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#FFBF57] animate-pulse" /> {block.video_caption || "Inauguración de sucursal"}
                </div>
              </div>
            </Reveal>
          )}
        <div className="grid gap-3 md:gap-4 content-center" data-testid="humanization-people">
          {people.map((p, i) => {
            const img = toFullUrl(p.image_url);
            return (
              <Reveal key={i} delay={i * 120}>
                <div className="group rounded-3xl bg-white border border-black/6 p-3 md:p-4 flex items-center gap-4 md:gap-5 hover:border-[#FFBF57]/60 transition-colors">
                  <div className="w-24 h-24 sm:w-28 sm:h-28 md:w-36 md:h-36 rounded-2xl overflow-hidden bg-[#18181B] shrink-0 relative">
                    {img ? <img loading="lazy" decoding="async" src={img} alt={p.name} className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-[1.05] transition-transform duration-700" /> : <Users2 size={28} className="text-white/30 absolute inset-0 m-auto" />}
                  </div>
                  <div className="min-w-0">
                    <div className="font-display text-lg md:text-2xl text-[#0A0A0A] leading-tight">{p.name}</div>
                    <div className="text-[10px] uppercase tracking-[0.2em] font-mono text-[#FFBF57] mt-1">{p.role}</div>
                    <p className="mt-2 text-xs md:text-sm text-[#3F3F46] leading-relaxed">{p.bio || p.quote}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
        </div>
      </div>
    </section>
  );
}
